import styled from "styled-components";
import { colors } from "../../theme/colors";
import { Box, Card, Grid, TextField } from "@mui/material";

export const StyledTopPart = styled(Box)`
  background-color: ${colors.primary};
  height: ${(props) => props.height};
  clip-path: ellipse(70% 45% at 50% 25%);
  position: relative;
  margin-top: -1px;
`;

export const StyledTextField = styled(TextField)`
  background: white;
  border-radius: 32px;

  & label.Mui-focused {
    color: ${colors.white.main};
    background-color: ${colors.white.main};
    border-radius: 0;
  }
  & .MuiInput-underline:after {
    border-bottom-color: ${colors.white.main};
    border-radius: 0;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${colors.white.main};
      border-radius: 32px;
    }
    &:hover fieldset {
      border-color: ${colors.white.main};
      border-radius: 32px 32px 32px 32px;
    }
    &.Mui-focused fieldset {
      border-color: ${colors.white.main};
      border-radius: 32px 32px 0 0;
      border-width: 0 10px 0 10px;
    }
  }
`;

export const StyledShopContainer = styled.div`
  & > div {
    position: relative;
    top: 0;
    transition: top ease 0.5s;
  }
`;

export const StyledShopContainerGrid = styled(Grid)`
  color: ${colors.gray.text2};

  &:hover > div {
    color: ${colors.secondary};
    cursor: pointer;

    &.shopText {
      text-decoration: underline;
    }

    & > div {
      top: -10px;
    }
  }
`;

export const StyledShopName = styled.div`
  height: ${(props) => (props.size ? `${props.size}px` : "60px")};
  width: ${(props) => (props.size ? `${props.size}px` : "60px")};
  background-color: ${colors.primary};
  color: ${colors.secondary};
  border-radius: 50%;
  font-size: ${(props) => props.size / 30 || "2rem"};
  text-align: center;

  & > span {
    line-height: ${(props) => props.size / 16 || "3.5rem"};
  }

  @media screen and (max-width: 600px) {
    height: ${(props) => (props.size ? `${props.size / 2}px` : "30px")};
    width: ${(props) => (props.size ? `${props.size / 2}px` : "30px")};
  }
`;

export const StyledFrontCard = styled(Grid)`
  position: absolute;
  top: 25%;
  width: 85vw !important;
  background-color: ${colors.white.main};
  box-shadow: 0px 2px 6px #00000029;
`;

export const StyledFrontCardSubtitle = styled.div`
  background-color: ${colors.purple.main};
  color: ${colors.white.main};
  font-size: 22px;
  border-radius: 24px;
  margin-top: 1rem;
  padding: 10px 10px 10px 20px;

  @media screen and (max-width: 600px) {
    font-size: 14px;
    padding: 5%;
  }
`;
